import axios from "axios";

const API_URL = import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8050";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 2000,
  headers: {
    "Content-Type": "application/json"
  }
});

export interface AdClickPayload {
  yclid?: string;
  ymClientId?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  landingUrl?: string;
}

export const attributionApi = {
  async createClick(payload: AdClickPayload): Promise<string> {
    const response = await api.post<{ code: string }>("/attribution/click", payload);
    return response.data.code;
  },

  async attach(payload: { code?: string; ymClientId?: string }): Promise<void> {
    await api.post("/attribution/attach", payload);
  }
};

/** Собирает рекламные метки из строки запроса */
export const readAdParams = (search: string): AdClickPayload => {
  const params = new URLSearchParams(search);

  return {
    yclid: params.get("yclid") || undefined,
    utmSource: params.get("utm_source") || undefined,
    utmMedium: params.get("utm_medium") || undefined,
    utmCampaign: params.get("utm_campaign") || undefined,
    utmTerm: params.get("utm_term") || undefined,
    utmContent: params.get("utm_content") || undefined
  };
};

export const hasAdParams = (payload: AdClickPayload): boolean => {
  return Boolean(payload.yclid || payload.utmSource || payload.utmCampaign);
};
